import type { AvailableLocales } from '@eliadmin/core/src/stores/locale-store';

export function getGdprUrl(): string {
  return '/gdpr';
}

export function getTosUrl(locale: AvailableLocales): string {
  return locale === 'cs' ? '/obchodni-podminky' : '/obchodne-podmienky';
}
